import e, { css as t } from "styled-components";
import { fontSizes as f } from "../constants.es.js";
import { X_POSITION as y } from "../../../constants/position.es.js";
import { Typography as n } from "../../Typography/Typography.es.js";
const o = e.span.withConfig({
  displayName: "ToggleSlider",
  componentId: "sc-1czidek-0"
})(["-webkit-transition:0.4s;background-color:var(--color-accent-secondary-weak);bottom:0;cursor:pointer;left:0;position:absolute;right:0;top:0;transition:0.4s;&:hover{background-color:var(--color-accent-secondary-default);}&:before{-webkit-transition:0.4s;background-color:var(--color-fg-inverse-default);border-radius:var(--size-border-radius-circle);content:'';left:0.2rem;position:absolute;top:0.2rem;transition:0.4s;}"]), l = e.input.withConfig({
  displayName: "ToggleInput",
  componentId: "sc-1czidek-1"
})(["height:0;opacity:0;width:0;&:checked + ", "{background-color:var(--color-accent-primary-default);&:hover{background-color:var(--color-accent-primary-strongest);}}&:focus + ", "{box-shadow:0 0 1px var(--color-accent-primary-default);}&:disabled{cursor:not-allowed;opacity:0.4;pointer-events:all !important;}"], o, o), u = e.label.withConfig({
  displayName: "ToggleLabel",
  componentId: "sc-1czidek-2"
})(["display:inline-block;height:3.4rem;position:relative;width:6rem;"]), T = e.div.withConfig({
  displayName: "ToggleHelperText",
  componentId: "sc-1czidek-3"
})(["align-items:center;color:inherit;display:flex;flex-wrap:wrap;font-size:1.4rem;margin-top:0.6rem;"]), z = e.div.withConfig({
  displayName: "Toggle",
  componentId: "sc-1czidek-4"
})(["", ""], ({
  disabled: s,
  error: d,
  labelPosition: p,
  size: i,
  success: g
}) => {
  var a, c;
  const r = `calc(var(--size-components-input-height-${i}) / 2)`, m = `var(--size-components-input-height-${i})`, h = f[i];
  return t(["", "{color:inherit;}", "{width:", ";height:", ";font-size:", ";}", "{border-radius:calc(", " / 2);}", ":before{width:calc(", " - 0.4rem);height:calc(", " - 0.4rem);}", ":checked + ", ":before{transform:translateX(", ");}", " ", " ", " ", ""], (a = n.S) == null ? void 0 : a.Typography, u, m, r, h, o, r, o, r, r, l, o, r, p === y.right && t(["", "{order:2;}"], (c = n.S) == null ? void 0 : c.Typography), d && t(["", ":checked ~ ", ":after{background-color:var(--color-error-default);}color:var(--color-error-strong);"], l, o), g && t(["color:var(--color-accent-primary-strongest);"]), s && t(["&,", "{cursor:not-allowed;opacity:0.4;pointer-events:all !important;}"], o));
}), I = e.div.withConfig({
  displayName: "ToggleBody",
  componentId: "sc-1czidek-5"
})(["align-items:center;display:flex;gap:var(--size-4);margin-bottom:var(--size-2);"]);
export {
  z as Toggle,
  I as ToggleBody,
  T as ToggleHelperText,
  l as ToggleInput,
  u as ToggleLabel,
  o as ToggleSlider
};
//# sourceMappingURL=style.es.js.map
